module.exports = __webpack_public_path__ + "media/partners/hallmark-7aabe5da.svg";